import { DemoUserObject } from "assets/data/usersData";
import { CustomComponentProps } from "utils/types/generalTypes";
import userIcon from "assets/img/user_icon.png";
import Button from "../core/Button";

export type MuteMemberProps = CustomComponentProps & {
    user: DemoUserObject;
};

const MuteMember = ({ user, className, style }: MuteMemberProps) => {
    return (
        <div className={`follow-user-li ${className}`} style={style}>
            <div className="d-flex flex-j-between">
                <div className="d-flex flex-j-start">
                    <img src={user.url || userIcon} alt={user.name} />
                    <div className="follow-user-li-text d-flex flex-col flex-a-start flex-j-center pl-10">
                        <h3>
                            <a href="#" className="dark-grey-text white-text">
                                {user.name.length > 10
                                    ? `${user.name.slice(0, 10)}...`
                                    : user.name}
                            </a>
                        </h3>
                        <span className="momeento-p">@{user.username}</span>
                    </div>
                </div>
                <Button text="Unmute" rounded color="" />
            </div>
        </div>
    );
};

export default MuteMember;
